import React, {FC} from 'react'

import LayoutDefault from '../LayoutDefault'

interface ILayoutAccountProps {
	className?: string
}

const LayoutAccount: FC<ILayoutAccountProps> = ({className, children}) => {
	return (
		<LayoutDefault hasMenuStub={false} className={className}>
			{children}
		</LayoutDefault>
	)
}

LayoutAccount.displayName = 'LayoutAccount'

export default LayoutAccount
